import React from "react";
import cn from "classnames";
import styles from "./styles.module.scss";
import useEvents from "@/hooks/useEvent";
import Body from "@/ui/Body";

const formatDate = (dateString) => {
  if (!dateString) return "";
  const date = new Date(`${dateString}T00:00:00`);
  const day = date.getDate();
  const month = date.toLocaleString("en-US", { month: "short" }).toUpperCase();
  const year = date.getFullYear();
  return `${day} ${month} ${year}`;
};

const defaultIntro = `<p>We have built both a digital and offline community, through hosting round table discussions, webinars, interactive panels, and lightning talks. Our latest event and podcast series – Let’s Get Disruptive, has created a unique platform for sharing experiences and discussing industry challenges.</p>`;

export const EventsSection = ({ title, intro = "", className }) => {
  const events = useEvents();
  const finalIntro = intro.length > 0 ? intro : defaultIntro;

  if (!events || events.length === 0) {
    return null;
  }

  return (
    <section id="events" className={cn(styles.eventsSection, className)}>
      <div className={styles.container}>
        {title && <h4 className={styles.mainTitle}>{title}</h4>}
        {finalIntro && (
          <div className={styles.intro}>
            <Body body={finalIntro} />
          </div>
        )}
        <div className={styles.grid}>
          {events.map((event) => (
            <div className={styles.card} key={event.id}>
              <div className={styles.imageWrapper}>
                <img src={event.image} alt={event.title} className={styles.image} />
              </div>
              <div className={styles.cardContent}>
                <div className={styles.metaRow}>
                  <span className={styles.tag}>
                    {event.location && event.location.length > 0 ? event.location : "Webinar"}
                  </span>{" "}
                  <span className={styles.date}>{formatDate(event.date)}</span>
                </div>
                <h3 className={styles.title}>{event.title}</h3>
              </div>
              <div className={styles.cardFooter}>
                <a href={event.link || "#"} className={styles.button}>
                  Access Webinar
                </a>
                <svg
                  className={styles.plusIcon}
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10 0C9.40292 0 8.91892 0.484027 8.91892 1.08108V8.91895H1.08108C0.484027 8.91895 0 9.40295 0 10C0 10.5971 0.484027 11.0811 1.08108 11.0811H8.91892V18.9189C8.91892 19.516 9.40292 20 10 20C10.5971 20 11.0811 19.516 11.0811 18.9189V11.0811H18.9189C19.516 11.0811 20 10.5971 20 10C20 9.40295 19.516 8.91895 18.9189 8.91895H11.0811V1.08108C11.0811 0.484027 10.5971 0 10 0Z"
                    fill="#3E3C3A"
                  />
                </svg>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default EventsSection;
